module.exports = __webpack_public_path__ + "static/media/img1-2.dbc2f498.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/biosense/biomasa/img1-2.png
// module id = 1265
// module chunks = 3